import React from 'react';

const Nbsp = () => (
  <span
    style={{
      whiteSpace: 'pre'
    }}>
    {' '}
  </span>
);

export default Nbsp;
